<ngx-spinner></ngx-spinner>
<div class="ttm-page-title-row">
  <div class="ttm-page-title-row-bg-layer ttm-bg-layer"></div>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="title-box ttm-textcolor-white">
          <div class="page-title-heading">
            <h1 class="title">Transparencia</h1>
          </div>
          <div class="breadcrumb-wrapper">
            <span>
              <a title="Homepage" routerLink="home"
                ><i class="ti ti-home"></i
              ></a>
            </span>
            <span class="ttm-bread-sep">&nbsp; / &nbsp;</span>
            <span
              ><span style="color: #0095d9; font-weight: bold"
                >Transparencia</span
              ></span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="site-main">
  <section class="ttm-row">
    <div class="container">
      <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-8">
          <div
            class="section-title with-desc title-style-center_text mb-55 clearfix"
          >
            <div class="title-header">
              <h2 class="title">
                Ley Orgánica de Transparencia y Acceso a la Información Pública
              </h2>
            </div>
          </div>
        </div>
        <div class="col-md-2"></div>
      </div>
      <div class="row mt-15">
        <div class="col-md-6">
          <p>
            ​La​
            <strong
              >Ley Orgánica de Transparencia y Acceso a la Información Pública
              (LOTAIP)</strong
            >
            plantea la participación ciudadana y el derecho de acceso a la
            información relacionada con asuntos p​úblicos, para ejercer un
            efectivo control y exigir la rendición de cuentas a las
            instituciones gubernamentales o aquellas que perciben recursos
            estatales. ​​
          </p>
          <p>
            En cumplimiento de la Ley Orgánica de Transparencia y Acceso a la
            Información Pública (LOTAIP), todas las entidades poseedoras de
            información pública están obligadas a difundir a través de su portal
            institucional, la siguiente información mínima actualizada.​​
          </p>
        </div>
        <div class="col-md-6">
          <div class="single-img" style="height: 100%">
            <img
              loading="lazy"
              style="
                width: 100%;
                height: 100%;
                object-position: center;
                object-fit: cover;
              "
              src="/assets/images/transparencia.jpg"
              alt=""
            />
          </div>
        </div>

        <div class="row col-12">
          <div class="col-12">
            <h5>Información pública</h5>
          </div>
          <div class="col-lg-5 col-md-5 col-sm-12">
            <div class="section-title clearfix">
              <h5 class="title">Año</h5>
              <select
                (ngModel)="(selectedOptionA)"
                id="selectAnioD"
                (change)="getMesTransparencia()"
              >
                <option *ngFor="let item of anios">
                  {{ item.anio }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-lg-5 col-md-5 col-sm-12">
            <div class="section-title clearfix">
              <h5 class="title">Mes</h5>
              <select (ngModel)="(selectedOptionM)" id="selectMesD">
                <option *ngFor="let item of meses">
                  {{ item.mes }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-lg-2 col-md-2 col-sm-12">
            <div class="section-title clearfix">
              <h5 class="title" style="color: #f8f9fa">ACCION</h5>
              <a
                class="ttm-btn ttm-btn-size-sm ttm-btn-shape-round ttm-btn-style-fill ttm-icon-btn-right ttm-btn-bgcolor-black"
                title=""
                (click)="buscarDocumentos()"
                >BUSCAR <i class="ti ti-search"></i
              ></a>
            </div>
          </div>
        </div>
        <div class="mt-3 col-12" id="tabla">
          <table style="width: 100%">
            <tr>
              <th></th>
              <th></th>
              <th></th>
            </tr>
            <tr *ngFor="let data of transparencias">
              <td>{{ data.nombre }}</td>
              <td style="padding-top: 1rem">
                <a
                  class="ttm-btn ttm-btn-size-sm ttm-btn-shape-round ttm-btn-style-fill ttm-icon-btn-right ttm-btn-bgcolor-black"
                  (click)="openPDFFile(data.url)"
                  target="_blank"
                  title=""
                  >Descargar<i class="ti ti-eye"></i
                ></a>
              </td>
              <td style="padding-top: 1rem">
                <!-- <a class="ttm-btn ttm-btn-size-sm ttm-btn-shape-round ttm-btn-style-fill ttm-icon-btn-right ttm-btn-bgcolor-skincolor"
                                (click)="downloadPDFFile(data.url)" target="_blank" title="" download>Descargar <i
                                    class="ti ti-download"></i></a> -->
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </section>

  <!-- <section class="ttm-row carrer-pos-section clearfix">
    <div class="container">
      <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-8">
          <div
            class="section-title with-desc title-style-center_text mb-55 clearfix"
          >
            <div class="title-header">
              <h2 class="title">
                Ley Orgánica de Transparencia y Acceso a la Información Pública
              </h2>
            </div>
          </div>
        </div>
        <div class="col-md-2"></div>
      </div>
      <div class="row"></div>
      <div class="row">
        <div class="container">
          <div class="row">
            <div class="col-md-12">
              <ul class="ttm-list ttm-list-style-icon">
                <li>
                  <i
                    class="ttm-textcolor-skincolor fa fa-arrow-circle-right"
                  ></i>
                  Art. 7 Difusión de Información Pública
                </li>
              </ul>
              Por la transparencia en la gestión administrativa que están
              obligadas a observar todas las instituciones del Estado que
              conforman el sector público en los términos del artículo 118 de la
              Constitución Política de la República y demás entes señalados en
              el artículo 1 de la presente Ley, difundirán a través de un portal
              de información o página web, así como de los medios necesarios a
              disposición del público, implementados en la misma institución, la
              siguiente información mínima actualizada, que para efectos de esta
              Ley se la considera de naturaleza obligatoria:
              <ul class="ttm-list ttm-list-style-icon">
                <li>
                  <i
                    class="ttm-textcolor-skincolor fa fa-arrow-circle-right"
                  ></i>
                  A. Organización Interna
                </li>
              </ul>
              Estructura orgánica funcional, base legal que la rige,
              regulaciones y procedimientos internos aplicables a la entidad;
              las metas y objetivos de las unidades administrativas de
              conformidad con sus programas operativos.
            </div>
          </div>
        </div>
        <br /><br />
        <br /><br />
      </div>
    </div>
  </section> -->
</div>
<section
  class="ttm-bgcolor-grey"
  style="padding-top: 3rem; padding-bottom: 10rem"
>
  <div class="container">
    <h4 class="title">Rendición de Cuentas</h4>
    <!-- <p>
      En el siguiente apartado puedes encontrar todos los documentos referentes
      a divulgación de información pública. Selecciona el año y mes a consultar
      y se desplegara todos los documentos relacionados, puedes verlos online o
      descargarlos.
    </p>
    <p>
      Puedes encontrar los informes anuales de rendición de cuentas a
      continuación:
    </p> -->

    <!-- <ul>
      <li>
        -
        <a
          target="_blank"
          href="https://aguasmachala.gob.ec/wp-content/uploads/2020/11/RENDICION-2019.pdf"
          style="font-weight: bold; text-decoration: underline"
          >Rendicion de Cuentas Año 2019</a
        >
      </li>
      <li>
        -
        <a
          target="_blank"
          href="https://aguasmachala.gob.ec/wp-content/uploads/2019/04/INFORME-DE-RENDICION-DE-CUENTAS-2018-AGUAS-MACHALA-1.pdf"
          style="font-weight: bold; text-decoration: underline"
          >Rendicion de Cuentas Año 2018
        </a>
      </li>
      <li>
        -
        <a
          target="_blank"
          href="https://aguasmachala.gob.ec/wp-content/uploads/2018/06/Rendicion-de-Cuentas-2017B.pdf"
          style="font-weight: bold; text-decoration: underline"
          >Rendicion de Cuentas Año 2017</a
        >
      </li>
    </ul> -->

    <div class="documents-accountability mt-4">
      <div
        class="acco-container"
        *ngFor="let accountability of accountabilities"
      >
        <div class="acco-year">
          <h5 class="border-title mb-0">
            <span>{{ accountability.anio }}</span>
          </h5>
        </div>

        <div>
          <ul class="rc_ul">
            <li
              class="acco-doc"
              *ngFor="let document of accountability.documentos"
            >
              <h6>
                <a
                  [href]="document.url"
                  target="_blank"
                  style="text-decoration: underline"
                  >{{ document.nombre }}</a
                >
              </h6>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>
